import { render } from "./TemplateTabs.vue?vue&type=template&id=986a9b96&ts=true"
import script from "./TemplateTabs.vue?vue&type=script&lang=ts"
export * from "./TemplateTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4136303564/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__